export default [
  {
    path: "/monitoring/unavailable-spklu",
    name: "unavailable-spklu",
    component: () =>
      import("../../views/monitoring_unavailable_spklu/unavailable_spklu"),
  },
];
